import React, { useState } from 'react';
import Input from '../Input/Input';
import Button from '../Button/Button';
import './Form.css';
import { Link } from 'react-router-dom';



const Form = () => {
  const [formData, setFormData] = useState({
    name: '',
    companyName: '',
    email: '',
    mobileNumber: '',
    message: ''
  });

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      
      const response = await fetch(`${process.env.REACT_APP_BACKEND_CONNECTION_URL}/submit-form`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
      });
      if (response.ok) {
        alert('Form submitted successfully');
      } else {
        alert('Error submitting form');
      }
    } catch (error) {
      console.log('Error:', error);
      alert('Error submitting form');
    }
  };

  return (
    <div className="form-container">
      <h2>Get a free trial</h2>
      <form onSubmit={handleSubmit}>
        <Input label="Name:*" type="text" name="name" value={formData.name} onChange={handleChange} />
        <Input label="Company Name:*" type="text" name="companyName" value={formData.companyName} onChange={handleChange} />
        <Input label="Email Address:*" type="email" name="email" value={formData.email} onChange={handleChange} />
        <Input label="Mobile number:*" type="tel" name="mobileNumber" value={formData.mobileNumber} onChange={handleChange} />
        <textarea className="textareamessage" placeholder="Message:" name="message" value={formData.message} onChange={handleChange} />
        <p className="privacy-policy">
          By clicking submit button, you agree to our <span><Link to='https://payment.tripta.in/TnC/PrivacyPolicy.html' target="_blank">Privacy Policy</Link></span>
        </p>
        <Button text="Submit" />
      </form>
    </div>
  );
};

export default Form;
